import { Shield, EyeOff, Layers, MessageCircleHeart, Heart } from "lucide-react";

const items = [
  { icon: Shield, title: "Datos emocionales anónimos", text: "Diseñados desde el principio para no identificar a nadie." },
  { icon: EyeOff, title: "Sin acceso individual para empresas", text: "Las empresas nunca ven datos de personas concretas." },
  { icon: Layers, title: "Información agregada", text: "Solo tendencias del equipo, nunca casos individuales." },
  { icon: MessageCircleHeart, title: "Acompañamiento confidencial", text: "Lo que el empleado expresa se queda con el empleado." },
  { icon: Heart, title: "Bienestar sin invasión", text: "Cuidamos el equilibrio entre apoyo y privacidad." },
];

export function Privacy() {
  return (
    <section id="privacidad" className="relative bg-surface py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1 text-xs font-medium text-muted-foreground">
            <Shield className="h-3 w-3 text-primary" /> Privacidad por diseño
          </span>
          <h2 className="mt-5 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Privacidad y confianza <br className="hidden sm:block" />
            <span className="text-gradient-brand">desde el diseño.</span>
          </h2>
        </div>
        <div className="mx-auto mt-16 grid max-w-5xl gap-4 md:grid-cols-2 lg:grid-cols-3">
          {items.map((it) => (
            <div key={it.title} className="rounded-3xl border border-border bg-card p-6 shadow-soft">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl gradient-soft">
                <it.icon className="h-4 w-4 text-primary" strokeWidth={2.2} />
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground">{it.title}</h3>
              <p className="mt-1.5 text-sm text-muted-foreground">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
